import React, { Component } from 'react';
import { getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import moment from 'moment';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';

 import 'moment/locale/de';
 import 'moment/locale/nl';
 import 'moment/locale/es';
 import 'moment/locale/fr';
 import 'moment/locale/it';
 import 'moment/locale/pt';

import './DatePicker.scss?nomodule';
class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: props.startDate ,
      endDate: props.endDate,
      focusedInput: null,
    };
  }

  componentDidMount() {
   const {currentLanguage} = this.props;
   
   moment.locale(currentLanguage);
  }


  render() {
    const {currentLanguage, startDateLabel, endDateLabel, changed } = this.props;
  
    return (
      <div >
       
        <DateRangePicker
          startDateId="start_date"
          endDateId="end_date"
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onDatesChange={({ startDate, endDate }) => { 
            this.setState({ startDate, endDate });
            changed(startDate, endDate)
          }}
         focusedInput={this.state.focusedInput}
         onFocusChange={(focusedInput) => { this.setState({ focusedInput })}}
         isOutsideRange={() => false} 
         locale={currentLanguage}
         startDatePlaceholderText={startDateLabel}
         endDatePlaceholderText={endDateLabel}
         showDefaultInputIcon
       
         readOnly
         inputIconPosition="after"
       
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
    return {
        currentLanguage: getActiveLanguage(state.locale).code
    };
};

export default connect(mapStateToProps)(DatePicker);



// WEBPACK FOOTER //
// ./src/components/atoms/DatePicker/index.js